import OutfitsProxy from '@/proxies/Outfits';
import OutfitsTransform from '@/transforms/Outfits';
import * as types from './mutation-types';

export default {
  async getItems({ commit, dispatch, getters }) {
    commit(types.LOADING, true);
    const proxy = new OutfitsProxy();
    try {
      const response = await proxy.getOutfits(getters.sort);
      commit(types.OUTFITS, [...OutfitsTransform.fetchCollection(response.outfits), {id: 'ball', team_id: -1, jersey: '', shorts: '', icon: 'i-ball-o--16'}]);
      commit(types.MORE, response.total > getters.items.length);
      commit(types.TOTAL, response.total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_outfits', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async getItem({ commit, dispatch }, payload) {
    const proxy = new OutfitsProxy();
    try {
      const response = await proxy.find(payload);
      commit(types.OUTFIT, ProjectsTransform.fetch(response.outfit));
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_outfit', {outfit_id: payload.id }], { root: true });
    }
  },
  async deleteItem({ commit, state }, payload) {
    const proxy = new OutfitsProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
      const deletionCount = Array.isArray(payload) ? payload.length : 1;
      commit(types.TOTAL, state.total - deletionCount);
    } catch (e) {
      // TODO
    }
  },
  sortItems({ commit, dispatch }, payload) {
    commit(types.SORT, payload);
    dispatch('getItems');
  },
  async refresh({ commit, getters }) {
    const proxy = new OutfitsProxy();
    try {
      const response = await proxy.getOutfits({ ...getters.sort, ...{ page: 1, limit: getters.items.length } });
      commit(types.OUTFITS, OutfitsTransform.fetchCollection(response.outfits));
    } catch (e) {
      // TODO
    }
  },
};
